import { makeSelectedEvent } from 'app/pages/TicketSalePage/slice/selectors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Ticket, TicketTypeBundle } from 'types/TicketsState';
import { getBundleFeePrice } from 'utils/bundles';
import { buildPriceToShow, getTaxPrice } from 'utils/tickets';

interface TicketTypeBundlePriceProps {
  ticketTypeBundle: TicketTypeBundle;
  ticketTypes: Ticket[];
}

const TicketTypeBundlePrice: React.FC<TicketTypeBundlePriceProps> = ({
  ticketTypeBundle: { price, absorbFees, items },
  ticketTypes,
}) => {
  const { t } = useTranslation();
  const { tax_rate, tax_included, currency, fees } =
    useSelector(makeSelectedEvent);

  const pricePaidForASingleBundle = tax_included
    ? price + getTaxPrice(price, tax_rate.rate)
    : price;
  const feePaidForASingleBundle = getBundleFeePrice(
    fees,
    ticketTypes,
    items,
    price,
  );
  const formattedPriceToShow = buildPriceToShow(
    pricePaidForASingleBundle,
    currency,
    t('ticketSale.free'),
  );

  const ticketIsSellable = true;

  return (
    <div
      className={`flex items-center h-fit w-fit absolute bottom-[8px] sm:top-0 sm:bottom-0 sm:left-[unset] sm:m-auto sm:right-[160px] ${
        ticketIsSellable ? '' : 'text-neutral-600'
      }`}
    >
      <p className="p2-semibold">{formattedPriceToShow}</p>
      {feePaidForASingleBundle > 0 && !absorbFees ? (
        <p className="p4-regular ml-[4px] text-neutral-800 lowercase">
          {'+'}
          {buildPriceToShow(feePaidForASingleBundle, currency)}
          {` (${t('ticketSale.fee')})`}
        </p>
      ) : null}
    </div>
  );
};

export default TicketTypeBundlePrice;
